"use client";

import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { queryClient } from "@/lib/query-client";
import { ReactNode, useEffect, useState } from "react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { GoogleOAuthReadyContext } from "@/components/login/useContext";

export function Providers({ children }: { children: ReactNode }) {
  const [googleClientId, setGoogleClientId] = useState<string | null>(null);

  useEffect(() => {
    // Fetch config at runtime from API endpoint
    // This allows using GOOGLE_CLIENT_ID (non-NEXT_PUBLIC) from Azure App Settings
    fetch("/api/config")
      .then((res) => res.json())
      .then((data) => {
        if (data.googleClientId) {
          setGoogleClientId(data.googleClientId);
        }
      })
      .catch((err) => {
        console.error("Failed to fetch config:", err);
      });
  }, []);

  // Render children without GoogleOAuthProvider if clientId is not available yet
  // This is fine - Google login will just not work until config loads
  // if (!googleClientId) {
  //   return (
  //     <QueryClientProvider client={queryClient}>
  //       {children}
  //       <ReactQueryDevtools initialIsOpen={false} />
  //     </QueryClientProvider>
  //   );
  // }

  return (
    <GoogleOAuthReadyContext.Provider value={!!googleClientId}>
      <QueryClientProvider client={queryClient}>
        {googleClientId ? (
          <GoogleOAuthProvider clientId={googleClientId}>{children}</GoogleOAuthProvider>
        ) : (
          children
        )}
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </GoogleOAuthReadyContext.Provider>
  );
}
